import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import usePageProps from 'hooks/usePageProps'
import Page from 'components/layout/Page'

const PrivacyPolicy = () => {
  const { simplicityPrivacyContent } = usePageProps()
  return (
    <Page>
      <Container maxWidth="md">
        <Grid
          size={12}
          pt={8}
        >
          <Typography
            variant="h1"
            align="center"
            sx={{ marginTop: 3 }}
          >
            <FormattedMessage id="SIMPLIFIED_PRIVACY_TITLE" />
          </Typography>

          <div dangerouslySetInnerHTML={{ __html: simplicityPrivacyContent }} />
        </Grid>
      </Container>
    </Page>

  )
}
export default memo(PrivacyPolicy)
